module.exports = __webpack_public_path__ + "img/cognitive_img01.7890c173.jpg";